/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Quantity_PositiveInputs */

const vi_form_err_quantity_positive = /** @type {(inputs: Form_Err_Quantity_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng phải lớn hơn 0`)
};

/**

* @param {Form_Err_Quantity_PositiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_quantity_positive = /** @type {((inputs?: Form_Err_Quantity_PositiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Quantity_PositiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_quantity_positive(inputs)
});